module.exports = __webpack_public_path__ + "media/images/icons/recommended-758b26f20de7a4cb72159d5b8fb46d14.svg";